// extracted by mini-css-extract-plugin
module.exports = {"loginForm":"loginForm--3OVxD"};